<template lang="pug">
v-fade-transition(mode="in-out" class="tw-p-0 tw-m-0")
  v-container(fluid fill-height class="tw-p-0 tw-h-screen tw-overflow-hidden")
    v-row(align="center" justify="space-between")
      v-col(cols="6" class="hidden-sm-and-down")
        v-card(tile :img="image" class="tw-h-screen tw-p-0 tw-m-0 tw-border-0")
      v-col(lg="6" cols="12")
        v-row(fill-height align="center" justify="center")
          v-col(lg="8" cols="10")
            v-row(align="center" justify="center")
              v-col(cols="auto")
                v-img(src="@/assets/images/kubiqa-logo.svg" width="300px")
            v-row(align="center" justify="center" class="tw-mt-8")
              v-col(class="text-center")
                div(class="tw-text-xl tw-font-bold tw-mb-2") {{ $t('Common.forgotPasswordHeadline') }}
                div(class="tw-text-base tw-mb-5 tw-italic") {{ $t('Common.forgotPasswordSubheadline') }}
                v-alert(v-if="sent" type="success" text role="status" class="tw-mb-5")
                  | {{ $t('Common.resetLinkSent') }}
                v-form(v-else ref="form" v-model="valid" lazy-validation @submit.prevent="submit" @keyup.native.enter="submit")
                  v-text-field(
                    v-model="email"
                    :rules="emailRules"
                    :label="$t('Common.email')"
                    color="blue darken-4"
                    required
                    autocomplete="email"
                    type="email"
                  )
                  v-btn(
                    type="submit"
                    color="rgba(94,129,244)"
                    elevation="0"
                    rounded
                    :loading="loading"
                    :disabled="loading"
                    class="tw-w-2/3"
                  )
                    span(class="tw-font-bold tw-uppercase") {{ $t('Common.sendResetLink') }}
                v-row(align="center" justify="center" class="tw-mt-3")
                  router-link(:to="{ name: 'Login' }" class="tw-text-sm tw-font-medium tw-text-blue-700 tw-underline")
                    | {{ $t('Common.login') }}
        v-snackbar(v-model="error" color="error") {{ error_message }}
</template>

<script>
import AuthService from '@/services/AuthService';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      valid: false,
      loading: false,
      sent: false,
      error: false,
      error_message: '',
      email: '',
      emailRules: [
        (value) => !!value || 'Please enter your email',
        (value) => !value || /^\S+@\S+\.\S+$/.test(value) || 'E-mail must be valid',
      ],
      image: require('@/assets/images/auth/real-estate-login.jpg'),
    };
  },
  methods: {
    async submit() {
      if (this.loading || !this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.error = false;
      this.sent = false;

      try {
        await AuthService.forgotPassword({ email: this.email.trim() });
        this.sent = true;
      } catch (error) {
        this.error_message = error.response && error.response.status === 429
          ? this.$t('Common.resetLinkRateLimited')
          : this.$t('Common.resetLinkFailed');
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
